import { LogOut } from "lucide-react";

import { IoMdSettings } from "react-icons/io";
import { useTranslation } from "react-i18next";
import UserProfileIcon from "@/_old/assets/icons/auth-dropdown/user-profile.svg?react";
import BookingsIcon from "@/_old/assets/icons/auth-dropdown/bookings.svg?react";
import MyOfficeIcon from "@/_old/assets/icons/auth-dropdown/myoffice.svg?react";
import MeetingRoomIcon from "@/_old/assets/icons/auth-dropdown/meeting-room.svg?react";
import WobaLogo from "@/_old/assets/woba.svg?react";
import { UserMenuItem } from "./user-menu-item";
import { useLogout } from "@/core/components/auth/hooks/useLogout";

export function UserMenu({ as = "dropdown" }: { as?: "dropdown" | "sheet" }) {
  const [translate] = useTranslation(["core"]);
  const { signOut } = useLogout();
  return (
    <>
      <UserMenuItem
        title={translate("user-menu-profile-link")}
        icon={() => <UserProfileIcon width={14} height={14} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/me`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-bookings-link")}
        icon={() => <BookingsIcon width={14} height={14} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/bookings`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-coworking-link")}
        icon={() => <MyOfficeIcon width={14} height={14} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/my-coworking`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-meetingrooms-link")}
        icon={() => <MeetingRoomIcon width={14} height={14} />}
        url={`${import.meta.env.VITE_LISTING_URL}?product=mr`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-home-link")}
        icon={() => <WobaLogo width={14} height={14} />}
        url={`${import.meta.env.VITE_PORTAL_URL}`}
        as={as}
      />

      <UserMenuItem
        title={translate("user-menu-settings-link")}
        icon={() => <IoMdSettings width={14} height={14} />}
        url={`${import.meta.env.VITE_PORTAL_URL}/profile/configuration`}
        as={as}
      />

      <UserMenuItem
        title={translate<string>("user-menu-logout")}
        icon={() => <LogOut width={14} height={14} />}
        onClick={() => {
          signOut();
        }}
        as={as}
      />
    </>
  );
}
